import { CraiActions, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Audit Actions`;
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
};

type SPCraiActionEnumLoc =
	| 'SPCraiActionEnumMarkInvalid'
	| 'SPCraiActionEnumMarkPending'
	| 'SPCraiActionEnumMarkValid'
	| 'SPCraiActionEnumNoAction'
	| 'SPCraiActionEnumRemoveFromAudit';
type CPCraiActionEnumLoc =
	| 'CPCraiActionEnumMarkInvalid'
	| 'CPCraiActionEnumMarkPending'
	| 'CPCraiActionEnumMarkValid'
	| 'CPCraiActionEnumNoAction'
	| 'CPCraiActionEnumRemoveFromAudit';

export const spCraiActionEnumLocs: LocDefs<SPCraiActionEnumLoc> = {
	SPCraiActionEnumMarkInvalid: {
		defaultValue: 'Mark Invalid',
		displayPath: `${dpRoot}|${CraiActions.MarkInvalid}`,
		description: `Audit action: '${CraiActions.MarkInvalid}'`,
		displayType: 'Content',
		portal: 'SP',
		...sharedProps,
	},
	SPCraiActionEnumMarkPending: {
		defaultValue: 'Mark Pending',
		displayPath: `${dpRoot}|${CraiActions.MarkPending}`,
		description: `Audit action: '${CraiActions.MarkPending}'`,
		displayType: 'Content',
		portal: 'SP',
		...sharedProps,
	},
	SPCraiActionEnumMarkValid: {
		defaultValue: 'Mark Valid',
		displayPath: `${dpRoot}|${CraiActions.MarkValid}`,
		description: `Audit action: '${CraiActions.MarkValid}'`,
		displayType: 'Content',
		portal: 'SP',
		...sharedProps,
	},
	SPCraiActionEnumNoAction: {
		defaultValue: 'No Action',
		displayPath: `${dpRoot}|${CraiActions.NoAction}`,
		description: `Audit action: '${CraiActions.NoAction}'`,
		displayType: 'Content',
		portal: 'SP',
		...sharedProps,
	},
	SPCraiActionEnumRemoveFromAudit: {
		defaultValue: 'Remove from Audit',
		displayPath: `${dpRoot}|${CraiActions.RemoveFromAudit}`,
		description: `Audit action: '${CraiActions.RemoveFromAudit}'`,
		displayType: 'Content',
		portal: 'SP',
		...sharedProps,
	},
};

export type SPCraiActionEnumLocType = LocMap<SPCraiActionEnumLoc>;

export const spCraiActionKeys: { [key in CraiActions]: keyof SPCraiActionEnumLocType } = {
	[CraiActions.MarkInvalid]: 'SPCraiActionEnumMarkInvalid',
	[CraiActions.MarkPending]: 'SPCraiActionEnumMarkPending',
	[CraiActions.MarkValid]: 'SPCraiActionEnumMarkValid',
	[CraiActions.NoAction]: 'SPCraiActionEnumNoAction',
	[CraiActions.RemoveFromAudit]: 'SPCraiActionEnumRemoveFromAudit',
};
